module.exports = __webpack_public_path__ + "img/privacy-ex-2.17ab6158.png";